import { noop } from 'angular';
import screenfull from 'screenfull';
import { EndCallReasons } from '../../common/services/doxy-analytics/tracks/video-session-end';
import { RootScopeEvents } from '../../common/services/root-scope-types';
import * as call from '../../modules/call';
import * as core from '../../modules/core';
import * as devices from '../../modules/devices';
import { extensionIntegrEvents } from '../../modules/extensions-framework/angular-integration/integration-types';
import * as localMedia from '../../modules/local-media';
import { CallNotifications } from '../video-chat.realtime-component';
class CallActionsController {
    /* @ngInject */
    constructor(globalUi, communicationControl, $timeout, VideoProviderFactory, VideoQualityService, currentUserHelper, videoSettingsHelper, trackingFactory, enableCameraErrorHandler, Browser, $rootScope, ModalFactory, modalsService, $translate, downgradeCallStateService, pn, $ngRedux, activeComponents) {
        this.globalUi = globalUi;
        this.communicationControl = communicationControl;
        this.$timeout = $timeout;
        this.VideoProviderFactory = VideoProviderFactory;
        this.VideoQualityService = VideoQualityService;
        this.currentUserHelper = currentUserHelper;
        this.videoSettingsHelper = videoSettingsHelper;
        this.trackingFactory = trackingFactory;
        this.enableCameraErrorHandler = enableCameraErrorHandler;
        this.Browser = Browser;
        this.$rootScope = $rootScope;
        this.ModalFactory = ModalFactory;
        this.modalsService = modalsService;
        this.$translate = $translate;
        this.downgradeCallStateService = downgradeCallStateService;
        this.pn = pn;
        this.$ngRedux = $ngRedux;
        this.activeComponents = activeComponents;
        this.isGalleryView = false;
        this.isQualityOpened = false;
        this.onToggleMenu = (isMenuButtonActive) => {
            this.isMenuButtonActive = isMenuButtonActive;
        };
        this.toggleMediaDelay = 200;
        this.onSpaceBarKeyup = this.toggleAudioOnSpaceBarKeyup.bind(this);
        this.isInFullscreen = false;
        this.isVideoBtnDisabled = false;
        this.isLoaded = false;
        this.canUsePaidFeatures = false;
        this.abilityChangeVideoQuality = false;
        this.unsubscribeFromStore = noop;
        this.ui = globalUi.ui;
        this.tooltipTrigger = Browser.tooltipTrigger();
        this.currentQuality = this.VideoQualityService.current.toUpperCase();
        this.pictureInPictureEnabled = document.pictureInPictureEnabled;
        void this.$timeout(() => {
            this.isLoaded = true;
        });
    }
    get loaded() {
        return this.isLoaded;
    }
    get canChangeVideoQuality() {
        return this.abilityChangeVideoQuality;
    }
    get isGalleryViewAvailable() {
        return this.canUsePaidFeatures;
    }
    get isFullscreen() {
        return this.isInFullscreen;
    }
    get videoBtnDisabled() {
        return this.isVideoBtnDisabled;
    }
    get audioBtnDisabled() {
        return this.isAudioBtnDisabled;
    }
    get activeVideoProvider() {
        return this.VideoProviderFactory.activeProvider;
    }
    $onInit() {
        this.unsubscribeFromStore = this.$ngRedux.connect((state) => ({
            hasVideo: localMedia.selectors.hasVideo(state),
            hasAudio: localMedia.selectors.hasAudio(state),
            hasMediaAccess: devices.selectors.selectMediaAccessability(state),
            isPiPTurnedOn: call.selectors.isPiPTurnedOn(state),
        }))(this);
        this.abilityChangeVideoQuality =
            this.videoSettingsHelper.canChangeVideoQuality(this.isPatient);
        this.canUsePaidFeatures = this.currentUserHelper.canUsePaidFeatures();
        const isGalleryViewActivated = window.localStorage.getItem('is-gallery-view-activated') === 'true';
        const isReturnToGalleryView = window.localStorage.getItem('is-return-to-gallery-view') === 'true';
        if (!isGalleryViewActivated && isReturnToGalleryView) {
            this.onToggleGalleryView({ status: isReturnToGalleryView });
        }
        else {
            this.onToggleGalleryView({ status: isGalleryViewActivated });
        }
        document.body.addEventListener('keyup', this.onSpaceBarKeyup);
    }
    $onDestroy() {
        this.unsubscribeFromStore();
        this.modalsService.close();
        this.$ngRedux.dispatch(core.actions.closeModal());
        document.body.removeEventListener('keyup', this.onSpaceBarKeyup);
    }
    getGalleryViewBtnText() {
        const key = this.ui.isGalleryViewActivated
            ? 'account.sidebar.video-controls.standardView'
            : 'account.sidebar.video-controls.galleryView';
        return this.$translate.instant(key);
    }
    enableWebcam() {
        this.VideoProviderFactory.activeProvider
            .enableWebcam()
            .then(() => this.ModalFactory.hideCurrentModal())
            .catch(this.enableCameraErrorHandler.onCommon.bind(this.enableCameraErrorHandler));
    }
    endAndRemove() {
        this.$rootScope.$emit(extensionIntegrEvents.DOCTOR_ENDED_CALL, this.pn.globalState);
        this.$rootScope.$emit(RootScopeEvents.ACTIVE_PROVIDER.END_REASON, EndCallReasons.CANCEL);
        this.communicationControl.removeEveryoneOnCall();
    }
    endAndLeave() {
        this.$rootScope.$emit(extensionIntegrEvents.PATIENT_ENDED_CALL, this.pn.globalState);
        this.$rootScope.$emit(RootScopeEvents.ACTIVE_PROVIDER.END_REASON, EndCallReasons.CANCEL);
        this.communicationControl.phoneStop();
        this.$rootScope.$emit(RootScopeEvents.REMOVE_CURRENT_PATIENT_FROM_WAITING_ROOM);
    }
    endAndHold() {
        this.$rootScope.$emit(extensionIntegrEvents.CALL_ON_HOLD);
        this.$rootScope.$emit(RootScopeEvents.ACTIVE_PROVIDER.END_REASON, EndCallReasons.PAUSE);
        this.communicationControl.phoneStop(CallNotifications.Hold);
    }
    tryEndCall() {
        if (this.Browser.isDesktop) {
            this.$ngRedux.dispatch(call.actions.endCallByUser(EndCallReasons.CANCEL));
        }
        else {
            this.$ngRedux.dispatch(call.actions.setEndCallAttempt());
        }
    }
    isShownImprovedMessage() {
        return this.downgradeCallStateService.isImproved() && this.pn.isPatient();
    }
    areSettingsActive() {
        return this.isQualityOpened || this.isMenuButtonActive;
    }
    toggleSidebar() {
        this.globalUi.toggleSidebar();
        this.trackingFactory.global.trackButtonClick({
            button_action: this.ui.sidebarHidden ? 'show sidebar' : 'hide sidebar',
            button_text: 'toggle sidebar',
            button_type: 'button',
            context: '',
        });
    }
    toggleFullScreen() {
        if (!Boolean(screenfull.enabled)) {
            return;
        }
        screenfull.toggle();
        void this.$timeout(() => {
            this.isInFullscreen = !this.isInFullscreen;
        });
    }
    togglePictureInPicture() {
        void this.$ngRedux.dispatch(call.actions.togglePiP());
    }
    toggleQuality() {
        if (!this.isPatient) {
            this.isQualityOpened = !this.isQualityOpened;
        }
    }
    toggleVideo() {
        if (this.isVideoBtnDisabled) {
            return;
        }
        this.$ngRedux.dispatch(localMedia.actions.toggleVideo());
        this.isVideoBtnDisabled = true;
        void this.$timeout(() => {
            this.isVideoBtnDisabled = false;
        }, this.toggleMediaDelay);
    }
    toggleAudio() {
        if (this.isAudioBtnDisabled) {
            return;
        }
        this.$ngRedux.dispatch(localMedia.actions.toggleAudio());
        this.isAudioBtnDisabled = true;
        void this.$timeout(() => {
            this.isAudioBtnDisabled = false;
        }, this.toggleMediaDelay);
    }
    toggleGalleryView(status) {
        if (status !== undefined) {
            window.localStorage.setItem('is-gallery-view-activated', status);
            this.onToggleGalleryView({ status });
        }
        else {
            window.localStorage.setItem('is-gallery-view-activated', String(!this.isGalleryView));
            this.onToggleGalleryView({ status: !this.isGalleryView });
            if (!this.isGalleryView) {
                this.isGalleryViewTooltipVisible = false;
            }
        }
    }
    toggleAudioOnSpaceBarKeyup(e) {
        const focused = document.querySelector(':focus');
        const focusedNode = focused?.nodeName;
        const isFocusedInput = ['TEXTAREA', 'INPUT', 'SELECT'].includes(focusedNode);
        // Avoid double-toggling when focus is on a call-actions control
        // (the focused control already handles the Space activation itself).
        const isFocusedInCallActions = Boolean(focused?.closest('.call-actions'));
        if (!isFocusedInput &&
            !isFocusedInCallActions &&
            this.activeVideoProvider.isInCall &&
            e.code === 'Space') {
            this.toggleAudio();
        }
    }
    onActionKeydown(e, action) {
        if (e.key !== 'Enter' && e.key !== ' ') {
            return;
        }
        e.preventDefault();
        action();
    }
    toggleChat() {
        this.activeComponents.chat.toggleChat();
    }
}
export { CallActionsController };
